import { Link } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import translate from "../../../i18n/translate";
import { ILearnerSessions } from "../../../interfaces";
import "./MyScheduleSummaryBlock.scss";
import allActions from "../../../redux/actions";
import CancelPopup from "./CancelPopup";
import ReschedulePopup from "./ReschedulePopup";

const AllSessionBlock = (props: any) => {
  const navigate = useNavigate();
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  const location = useLocation();
  const [isSkillGroup, setIsSkillGroup] = useState(false);
  const [upcomingSession, setUpcomingSession] = useState(0);
  const [openPopup, setOpenPopup] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [cancelProps, setCancelProps] = useState({} as ILearnerSessions);

  const handleCancel = (cancelData: any) => {
    setOpenCancel(true);
    setCancelProps(cancelData);
  };

  const handleClick = (sessionId: any) => {
    setOpenPopup(true);
    if (sessionStorage.getItem("RescheduleChkBox") === "False") {
      setUpcomingSession(sessionId);
    } else {
      setOpenPopup(false);
      openRescheduleWindow(sessionId);
    }
  };

  const openRoomWindow = (classRoomLink: any) => {
    const w = window.screen ? window.screen.availWidth - 10 : 7680;
    const h = window.screen ? window.screen.availHeight - 70 : 4320;
    const roomWindow = window.open(
      classRoomLink,
      "Classroom Window",
      `height=${h},width=${w},dependent=yes,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no`
    );
    roomWindow?.focus();
  };

  const viewSessionReport = (sessionId: any) => {
    navigate(`/sessionreport/${sessionId}`,{state: { productId: (location as { state?: { productId?: number } }).state?.productId },});
  };

  const openRescheduleWindow = (sessionId: any) => {
    const w = window.screen ? window.screen.availWidth - 10 : 630;
    const h = window.screen ? window.screen.availHeight - 70 : 440;
    const rescheduleWindow = window.open(
      `${process.env.REACT_APP_TMS_URL}/v2/sessions/${sessionId}/reschedule`,
      "Reschedule Session",
      `height=${h},width=${w},dependent=yes,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no`
    );
    rescheduleWindow?.focus();
    checkWindowCloseTimer(rescheduleWindow);
  };

  const checkWindowCloseTimer = (learnerWindow: any) => {
    const checkTimer = setInterval(() => {
      if (learnerWindow.closed) {
        clearInterval(checkTimer);
        const courseId = Number(sessionStorage.getItem("courseId")) || 0;
        if (!allInfo.createSessionService.isLoading) {
          dispatch(allActions.createSessionServiceAction.createSessionService(courseId));
        }
        if (!allInfo.tmsLearnerSessions.isLoading) {
          dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
        }
      }
    }, 1000);
  };

  useEffect(() => {
    if (allInfo.peopleInformation.data) {
      const licenseList = allInfo.peopleInformation.data.getpeopleInformation.license;
      if (licenseList) {
        const sprintGroupsCheck = licenseList.some((prod: any) => prod.productId === "29");
        setIsSkillGroup(sprintGroupsCheck);
      }
    }
  }, [allInfo.peopleInformation.data]);

  const renderSessions = () => {
    const { UpcomingData, records } = props;
    const sessionKeys = Object.keys(UpcomingData);
    if (sessionKeys.length === 0) {
      return (
        <div className="nosessions-container">
          <span>{translate(`myschedule_no_${records.replace(/\s+/g, '_').toLowerCase()}`)}</span>
        </div>
      );
    }
    return sessionKeys.map((key, index) => {
      const sessionData = UpcomingData[key];
      const {
        SessionNumber,
        CoachName,
        Session_GetstartDate,
        StartTime,
        DurationMins,
        IconType,
        SessionId,
        SessionLocation,
        studentStatus,
      } = sessionData;

      const handleCancelClick = () => handleCancel(sessionData);
      const handleRescheduleClick = () => handleClick(SessionId);
      const handleRoomWindowOpen = () => openRoomWindow(SessionLocation);
      const handleSessionReportClick = () => viewSessionReport(SessionId);

      return (
        <div key={index} className="session-details-wrapper">
          <div className="details-conatiner first-column">
            <span>{translate("myschedule_sessionDetails_sessions")}</span>
            <div>{studentStatus != "canceled" ? SessionNumber : '' }</div>
          </div>

          <div className="details-conatiner second-column">
            <span>{translate("myschedule_sessionDetails_teacher_name")}</span>
            <div>{CoachName}</div>
          </div>

          <div className="details-conatiner third-column">
            <span>
              {translate("myschedule_sessionDetails_date")}/{translate("myschedule_sessionDetails_time")}/
              {translate("myschedule_sessionDetails_durationText")}
            </span>
            <div>
              {`${Session_GetstartDate} / ${StartTime} / ${DurationMins} `}
              {translate("myschedule_sessionDetails_min")}
            </div>
          </div>

          <div className="details-conatiner fourth-column">
            <span>{translate("SessionRating_status")}</span>
            <div>
              {IconType === "Cancel" && (
                <span className="Reschedule_text_button" onClick={handleCancelClick} onKeyDown={() => {}}>
                  {translate("profile_cancelLabel")}
                </span>
              )}

              {IconType === "Reschedule" && !isSkillGroup && (
                <span className="Reschedule_text_button" onKeyDown={() => {}} onClick={handleRescheduleClick}>
                  {translate("myschedule_reschedule_button")}
                </span>
              )}

              {(studentStatus === "finished" || studentStatus === "canceled" || studentStatus === "lost") && (
                <span className={`button primary ${studentStatus}`}>
                  {studentStatus.charAt(0).toUpperCase() + studentStatus.slice(1)}
                </span>
              )}
            </div>
          </div>

          {!sessionStorage.getItem("isDemoUser") && (
            <>
              <div className="details-conatiner fifth-column">
                <span>{translate("SessionReport_sessionReview")}</span>
                <div>
                  {studentStatus === "finished" ? (
                    <Link className="RatingLinks" onClick={handleRoomWindowOpen}>
                      {translate("SessionReport_sessionReview")}
                    </Link>
                  ) : (
                    "N/A"
                  )}
                </div>
              </div>

              <div className="details-conatiner sixth-column">
                <span>{translate("SessionReport_sessionReport")}</span>
                <div>
                  {studentStatus === "finished" ? (
                    <Link className="RatingLinks"  onClick={handleSessionReportClick}>
                      {translate("myschedule_homepage_view")}
                    </Link>
                  ) : (
                    <div>N/A</div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      );
    });
  };

  return (
    <div className="Table-Container">
      <div className="sessions-information-container">{renderSessions()}</div>

      {openCancel && (
        <CancelPopup
          cancelProps={cancelProps}
          setCancelPopUp={setOpenCancel}
          openCancel={openCancel}
          setJoinNow={props.setJoinNow}
          isLatestCancel={false}
        />
      )}

      {openPopup && (
        <ReschedulePopup
          currentSessionId={upcomingSession}
          openPopup={openPopup}
          setPopupState={setOpenPopup}
          handleDispatch={props.handleDispatch}
          prodName={props.prodName}
        />
      )}
    </div>
  );
};

export default AllSessionBlock;
